<!-- 公共头部 -->
<template>
  <div class="comHeaderWrap">
    <div class="comHeader">
      <div
        style="
          max-width: 1280px;
          width: 100%;
          padding: 0 0px;
          height: 70px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="logo">
          <router-link :to="{ name: 'Home' }">
            <span
              style="
                font-size: 36px;
                color: white;
                font-weight: 500;
                font-family: '庞门正道标题';
              "
              >司法大数据&thinsp;/&thinsp;查全&thinsp;/&thinsp;查准</span
            >
            <!-- <img src="../assets/imgs/logo.png" alt="" style="width: 36px" /> -->
          </router-link>
        </div>
        <div class="comHeader_right">
          <div class="comHeader_right" style="font-family: '思源黑体CN'">
            <!-- <el-button type="text">
            <router-link
              :to="{ name: 'Home' }"
              class="homeLink"
              style="font-family: '思源黑体CN'; font-size: 21px"
            >
              首页
            </router-link>
          </el-button>
          <el-button
            type="text"
            disabled
            style="font-family: '思源黑体CN'; font-size: 21px"
            >帮助</el-button
          > -->
            <span
              type="text"
              v-if="loginshow !== ''"
              style="
                font-family: '思源黑体CN';
                color: #dc7b2e;
                color: white;
                font-size: 16px;
                text-align: right;
              "
              :style="'width:' + (user_name.length * 25 + 50) + 'px'"
              >欢迎！{{ user_name }}</span
            >

            <span
              plain
              type="text"
              @click="loginUnified"
              v-if="loginshow == ''"
              style="font-family: '思源黑体CN'; width: 36px; cursor: pointer"
            >
              <span
                class="logintext"
                style="font-size: 18px; color: #ffffff; font-weight: 900"
                >登录</span
              ></span
            >

            <el-dropdown v-if="loginshow !== ''">
              <div>
                <!-- <i
                class="iconfont el-icon-user-solid"
                style="font-size: 36px"
              ></i> -->
                <img
                  src="../assets/imgs/图标/个人中心-登录.png"
                  style="width: 30px; margin-left: 10px"
                  alt=""
                />
              </div>
              <el-dropdown-menu
                slot="dropdown"
                :style="
                  userType == 'ip' || userType == 'user'
                    ? 'width: 150px'
                    : 'width: 120px'
                "
              >
                <el-dropdown-item v-if="userType == 'ip' || userType == 'user'"
                  ><span @click="dialogTableVisible = true">
                    <i class="el-icon-user-solid"></i>登录个人账号</span
                  ></el-dropdown-item
                >
                <el-dropdown-item v-if="userType == 'ip' || userType == 'user'"
                  ><span @click="enrollde()"
                    ><i class="el-icon-edit-outline"></i>注册个人账号</span
                  ></el-dropdown-item
                >
                <el-dropdown-item v-if="userType == 'ipuser'"
                  ><span @click="personal()"
                    ><i class="el-icon-user"></i>个人中心</span
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><span @click="logout()">
                    <i class="el-icon-switch-button"></i>退出登录</span
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <!-- 登录功能 -->
            <el-dialog
              :title="backShow ? '密码找回' : '账号登录'"
              :visible.sync="dialogFormVisible"
              :show-close="false"
              :width="'420px'"
              append-to-body="true"
              :appendToBody="true"
            >
              <el-form
                :model="form"
                status-icon
                ref="ruleForm"
                class="demo-ruleForm el_form"
                key="form"
                v-if="!backShow"
              >
                <!-- :rules="rules" -->
                <el-form-item prop="username">
                  <el-input
                    v-model="form.username"
                    autocomplete="off"
                    placeholder="请输入账号/用户名"
                  >
                    <i slot="prefix" class="el-icon-user-solid"></i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="pass" class="m_top_20">
                  <el-input
                    type="password"
                    v-model="form.pass"
                    autocomplete="off"
                    placeholder="请输入密码"
                    show-password
                  >
                    <i slot="prefix" class="iconfont icon-mima"></i>
                  </el-input>
                </el-form-item>
              </el-form>
              <div class="backPass">
                <span @click="back" v-if="!backShow">忘记密码？</span>
                <!-- <span  @click="back" v-if="backShow">登&emsp;&emsp;录</span> -->
              </div>
              <el-form
                :model="backForm"
                status-icon
                ref="back_form"
                class="demo-ruleForm el_form"
                key="back_form"
                v-if="backShow"
                :rules="rules"
                label-width="100px"
              >
                <!-- :rules="rules" -->
                <el-form-item label="账号类型:" prop="type">
                  <el-radio-group v-model="backForm.type">
                    <el-radio label="1">机构账号</el-radio>
                    <el-radio label="2">个人账号</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="电子邮箱:" prop="email">
                  <el-input
                    v-model="backForm.email"
                    autocomplete="off"
                    placeholder="请输入邮箱地址"
                    style="width: 100%"
                  >
                    <i slot="prefix" class="el-icon-message"></i>
                  </el-input>
                </el-form-item>
              </el-form>
              <!-- <div class="backPass">
              <span  @click="back" v-if="!backShow">忘记密码？</span>
              <span  @click="back" v-if="backShow">去&emsp;登&emsp;录</span>
            </div> -->
              <div slot="footer" class="dialog-footer" v-if="backShow">
                <el-button type="primary" @click="backPassword('back_form')"
                  >找回密码</el-button
                >
              </div>
              <div slot="footer" class="dialog-footer" v-if="!backShow">
                <el-button type="primary" @click="submitForm('ruleForm')"
                  >漫游登录</el-button
                >
                <el-button type="primary" @click="submitIp('ruleForm')"
                  >IP登录</el-button
                >
              </div>
            </el-dialog>
            <!-- IP用户登录 -->
            <el-dialog
              title="个人用户登录"
              :visible.sync="dialogTableVisible"
              :show-close="false"
              :width="'420px'"
              append-to-body="true"
              :appendToBody="true"
            >
              <el-form
                :model="form"
                status-icon
                ref="ruleForm"
                class="demo-ruleForm el_form"
                key="form"
              >
                <!-- :rules="rules" -->
                <el-form-item prop="username">
                  <el-input
                    v-model="form.username"
                    autocomplete="off"
                    placeholder="请输入账号/用户名"
                  >
                    <i slot="prefix" class="el-icon-user-solid"></i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="pass" class="m_top_20">
                  <el-input
                    type="password"
                    v-model="form.pass"
                    autocomplete="off"
                    placeholder="请输入密码"
                  >
                    <i slot="prefix" class="iconfont icon-mima"></i>
                  </el-input>
                </el-form-item>
              </el-form>
              <p class="successText" v-if="suc">
                登录成功，将于<span>{{ countDown }}</span
                >后跳转到首页！
              </p>
              <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="iplogin('ruleForm')"
                  >登录</el-button
                >
                <el-button type="primary" @click="enrollde()">注册</el-button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <div class="comHeader_bottom">
      <!-- <router-link :to="{ name: 'Home' }" style="width:230px;"
          >
      <span class="title_logo">哲思司法大数据</span></router-link> -->
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        style="height: 60px; display: flex; align-items: center; margin: auto"
      >
        <!-- <el-menu-item index="1">首页</el-menu-item> -->
        <!-- <router-link :to="{ name: 'Home' }"
          ><img
            src="../assets/imgs/logo.png"
            alt=""
            style="width: 40px; margin-right: 10px"
        /></router-link> -->
        <el-menu-item
          index="1"
          style="
            font-family: '思源黑体CN';
            color: #333333;
            font-size: 20px;
            width: 120px;
            text-align: center;
          "
          class="opening_"
          >首页</el-menu-item
        >
        <el-menu-item
          index="2"
          style="
            font-family: '思源黑体CN';
            color: #333333;
            font-size: 20px;
            width: 120px;
            text-align: center;
          "
          class="opening_"
          >搜案例</el-menu-item
        >
        <el-menu-item
          index="3"
          disabled
          style="
            font-family: '思源黑体CN';
            font-size: 20px;
            color: #333333;
            width: 120px;
            text-align: center;
          "
          >搜律所</el-menu-item
        >
        <el-menu-item
          index="4"
          style="
            font-family: '思源黑体CN';
            font-size: 20px;
            color: #333333;
            width: 120px;
            text-align: center;
          "
          class="opening_"
          >法律法规</el-menu-item
        >
        <el-menu-item
          index="5"
          style="
            font-family: '思源黑体CN';
            font-size: 20px;
            color: #333333;
            width: 120px;
            text-align: center;
          "
          class="opening_"
          >搜企业</el-menu-item
        >
        <!-- <el-menu-item
          index="5"
          disabled
          style="
            font-family: '思源黑体CN';
            font-size: 20px;
            color: #333333;
            margin-right: 36px;
          "
          >搜全文</el-menu-item
        > -->
        <!-- <el-menu-item
          index="6"
          
          style="
            font-family: '思源黑体CN';
            font-size: 20px;
            color: #333333;
            margin-right: 36px;
          "
          >高级检索</el-menu-item
        > -->
        <!-- <el-menu-item index="6" style="font-family: '思源黑体CN';color: #333333;font-size:21px;margin-right:36px;">高级检索</el-menu-item> -->
      </el-menu>
    </div>

    <!-- <div class="unified" v-show="loginShow"><i class="el-icon-circle-close" style="" @click="hides"></i><div id="T_login"></div></div> -->
  </div>
</template>

<script>
import store from "@/store";
export default {
  data() {
    return {
      loginshow: "",
      activeIndex: "1",
      dialogFormVisible: false,
      dialogTableVisible: false,
      form: {
        username: "",
        pass: "",
      },
      formLabelWidth: "120px",
      userType: null,
      // v1: new Tlogin({
      //   code: "ykzs",
      //   url: "http://192.168.44.105:8082/",
      //   type: 2,
      //   id: "T_login",
      // }),
      // loginShow: false,
      // code: "",
      backForm: {
        type: "",
        email: "",
      },
      backShow: false,
      rules: {
        type: [
          { required: true, message: "请选择账号类型", trigger: "change" },
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      user_name: "",
      centerDialogVisible: false,
      countDown: 0, // 页面上显示的倒计时数字
      timerThree: null, // 倒计时的对象
      suc: false,
    };
  },
  components: {},

  computed: {},
  created() {
    if (store.getCookie("token_S")) {
      this.loginshow = store.getCookie("token_S");
      this.userType = window.localStorage.getItem("userType");
    }
    if (window.localStorage.getItem("userName")) {
      this.user_name = window.localStorage.getItem("userName");
    }

    // this.submitIp();
    // console.log(this.userType);
  },
  inject: ["reload"],
  watch: {
    $route: {
      handler() {
        if (this.$route.query.code) {
          this.code = this.$route.query.code;
          // console.log(this.code);
          // this.reload()
          this.$http
            .post("/userauth", {
              code: this.code,
              appcode: "ykzs",
            })
            .then((res) => {
              // console.log(res);
              if (res.data.code == 200) {
                store.setCookie("token_S", res.data.data.access_token);
                window.sessionStorage.setItem("userType", res.data.data.role);
                this.userType = res.data.data.role;
                // this.reload();
              }
            })
            .catch((error) => {
              console;
            });
        }
      },
      deep: true,
    },
    $route: {
      handler: function (val, oldVal) {
        console.log(val);
        if (
          val.name == "LawsStatute" ||
          val.name == "AdvancedLaws" ||
          val.name == "LawsDetail"
        ) {
          this.activeIndex = "4";
        } else if (
          val.name == "Case" ||
          val.name == "Advanced" ||
          val.name == "Detail" ||
          val.name == "original"
        ) {
          this.activeIndex = "2";
        } else if (val.name == "LawFirm" || val.name == "LawsDetails") {
          this.activeIndex = "3";
        } else if (
          val.name == "Companies" ||
          val.name == "CompaniesHome" ||
          val.name == "CompaniesDetails"
        ) {
          this.activeIndex = "5";
        } else {
          this.activeIndex = "1";
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  // mounted() {
  //   document.addEventListener("click", (e) => {
  //     if (e.target.className != "unified") {

  //       // if ((this.loginShow == true)) {
  //       //   console.log("aa");
  //       //   this.loginShow = false;
  //       // }
  //     }
  //   });
  // },
  methods: {
    loginUnified() {
      // this.$emit('unifiedLogin', true)
      // console.log("aa")
      // this.loginShow = true;
      this.dialogFormVisible = true;
      this.backShow = false;
    },
    hides() {
      // this.loginShow = false;
    },
    // 漫游登录
    submitForm(formName) {
      this.dialogFormVisible = false;
      // console.log(formName);
      // console.log(this.form.username);
      // console.log(this.form.pass);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post("/login", {
              name: this.form.username,
              password: this.form.pass,
            })
            .then((res) => {
              // console.log(res);
              // if (res.data.code != 200) {
              //   this.$message({
              //     message: res.data.message,
              //     type: "warning",
              //     center: true,
              //   });
              //   return;
              // }
              if (res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: "success",
                  customClass: "message",
                  center: true,
                });
                store.setCookie("token_S", res.data.data.access_token);
                window.localStorage.setItem("userType", res.data.data.role);
                window.localStorage.setItem("userName", res.data.data.name);
                // this.userType = res.data.data.role,

                // console.log(this.userType)
                // console.log(this.loginshow);
                //   var uname = res.data.data.instituName;
                // this.loginshow = false;
                this.reload();
              }
            });
        } else {
          // console.log("error submit!!");
          // return false;
        }
      });
    },
    // IP登录
    submitIp(formName) {
      // this.dialogFormVisible = false;
      // console.log(this.form.username)
      // console.log(this.form.pass)
      this.$http
        .post("/iplogin", {
          //   name: this.form.username,
          //   password: this.form.pass,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.code != 200) {
            // this.$message({
            //   message: res.data.message,
            //   type: "warning",
            //   center: true,
            // });
            // return;
          }
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
              customClass: "message",
              center: true,
            });

            store.setCookie("token_S", res.data.data.access_token);
            window.localStorage.setItem("userType", res.data.data.role);
            window.localStorage.setItem("userName", res.data.data.name);
            // this.userType = res.data.data.role;
            // console.log(window.sessionStorage.getItem("userType"));
            // this.dialogTableVisible = true
            this.reload();
            // this.$http
            //   .get("/me", {})
            //   .then((res) => {
            //     console.log(res);
            //   })
            //   .catch((error) => {});
            // this.$router.push({
            //   name: "index",
            // });
          }
        })
        .catch((error) => {});
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //   } else {
      //     // console.log("error submit!!");
      //     return false;
      //   }
      //   // this.dialogTableVisible = true
      // });
    },
    // IP用户登录
    iplogin(formName) {
      this.dialogTableVisible = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post("/ipuserlogin", {
              name: this.form.username,
              password: this.form.pass,
            })
            .then((res) => {
              // console.log(res);
              // if (res.data.code != 200) {
              //   this.$message({
              //     message: res.data.message,
              //     type: "warning",
              //     center: true,
              //   });
              //   return;
              // }
              // this.centerDialogVisible = true;
              if (res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: "success",
                  customClass: "message",
                  center: true,
                });
                // this.suc = true;

                // const TIME_COUNT = 3; // 3s的倒计时变量
                // if (!this.timerThree) {
                //   // 没有倒计时在执行
                //   this.countDown = TIME_COUNT;
                //   this.timerThree = setInterval(() => {
                //     if (this.countDown > 0 && this.countDown <= TIME_COUNT) {
                //       this.countDown--;
                //     } else {
                //       clearInterval(this.timerThree); // 停止循环执行
                //       this.timerThree = null; // 倒计时对象置为null
                //       // 要执行的代码，例如页面跳转等
                //       // todos...
                //       console.log("aaaa");
                //       this.dialogTableVisible = false;
                //       this.$router.push({ path: "/" });
                //     }
                //   }, 1000); // 1s执行一次
                // }

                store.setCookie("token_S", res.data.data.access_token);
                this.dialogTableVisible = false;
                window.localStorage.setItem("userType", res.data.data.role);
                window.localStorage.setItem("userName", res.data.data.name);
                // this.userType = res.data.data.role,
                // console.log(window.sessionStorage.getItem("userType"))
                this.$http
                  .get("/me", {})
                  .then((res) => {
                    // console.log(res);
                    store.setCookie("user_id", res.data.data.user_id);
                    store.setCookie("role", res.data.data.role);
                  })
                  .catch((error) => {});
                this.reload();
                // this.$router.push({
                //   name: "index",
                // });
              }
            });
        } else {
          // console.log("error submit!!");
          return false;
        }
      }, 20000);
    },
    // IP用户注册
    enrollde() {
      this.$router.push("/login");
    },
    // 找回密码
    back() {
      this.backShow = !this.backShow;
    },
    backPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.backForm);
          this.$http.post("/forgetpass", this.backForm).then((res) => {
            // console.log(res);
            // if (res.data.code != 200) {
            //   this.$message({
            //     message: res.data.message,
            //     type: "warning",
            //     center: true,
            //   });
            //   return;
            // }
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: "success",
                customClass: "message",
                center: true,
              });
              this.dialogFormVisible = false;
              // store.setCookie("token_S", res.data.data.access_token, 7);
              // window.sessionStorage.setItem("userType", res.data.data.role);
              // this.userType = res.data.data.role,

              // console.log(this.userType)
              // console.log(this.loginshow);
              //   var uname = res.data.data.instituName;
              // this.loginshow = false;
              // this.reload();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    delCookie() {
      var cookies = document.cookie.split(";");

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        console.log(cookie);
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
          name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      }
      if (cookies.length > 0) {
        // console.log('cos')
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf("=");
          console.log(cookie);
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          var domain = location.host.substr(location.host.indexOf("."));
          document.cookie =
            name +
            "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" +
            domain;
        }
      }
    },
    // 退出
    logout() {
      store.clearCookie("token_S");
      store.clearCookie("user_id");
      store.setCookie("valid_copy", 0);
      // this.delCookie();//调用

      // store.clearCookie("valid");

      // console.log(this.$route.name);
      // if (this.$route.name != "Home") {
      // this.$router.push({
      //   path: "/",
      // });
      // }
      this.$message({
        message: "已退出登录状态",
        type: "success",
      });
      // window.location.href = window.location.origin;

      this.$router.push({ path: "/" });

      // this.$router.go(0)
      // this.reload();
    },
    // 切换导航栏
    handleSelect(key, keyPath) {
      //   console.log(key, keyPath);
      if (store.getCookie("token_S")) {
        if (key == "1") {
          if (this.$route.path !== "/") {
            this.$router.push({ path: "/" });
            // window.sessionStorage.setItem("searchinput", "");
            // window.sessionStorage.setItem("search", "");
          }
        }
        if (key == "2") {
          if (this.$route.path !== "/case") {
            this.$router.push({ path: "/case" });
            // window.sessionStorage.setItem("searchinput", "");
            // window.sessionStorage.setItem("search", "");
            window.localStorage.setItem("search_new", "[]");
          }
        }
        if (key == "3") {
          if (this.$route.path !== "/lawFirm") {
            this.$router.push({
              path: "/lawFirm",
              // query: {
              //   page: 1,
              //   pagesize: 10,
              //   search: "",
              //   city: "",
              //   year: "",
              // },
            });
            window.sessionStorage.removeItem("lawSearch");
          }
        }
        if (key == "4") {
          if (this.$route.path !== "/lawsStatute") {
            this.$router.push({ path: "/lawsStatute" });
            window.sessionStorage.removeItem("laws");
          }
        }
        if (key == "5") {
          this.$router.push({ path: "/companiesHome" });
        }
        if (key == "6") {
          this.$router.push({ path: "/transcript" });
        }
        if (key == "7") {
          // this.$router.push({ path: "/advanced" });
        }
      }
      if (!store.getCookie("token_S")) {
        this.$message.error("请先登录");
      }
    },
    personal() {
      this.$router.push({
        path: "/personal",
      });
    },
  },
  mounted() {
    let _this = this;
    setTimeout(function () {
      // console.log(_this.$route.path);
      if (_this.$route.path == "/case") {
        _this.activeIndex = "2";
      }
      if (_this.$route.path == "/lawFirm") {
        _this.activeIndex = "3";
      }
      if (_this.$route.path == "/lawsStatute") {
        _this.activeIndex = "4";
      }
      if (_this.$route.path == "/") {
        _this.activeIndex = "1";
      }
      if (
        _this.$route.path == "/companies" ||
        _this.$route.path == "/companiesHome" ||
        _this.$route.path == "/companiesDetails"
      ) {
        _this.activeIndex = "5";
      }
    }, 100);
  },
};
</script>
<style lang='less' scoped>
.successText {
  font-size: 18px;
  margin-bottom: 10px;
  span {
    color: rgb(92, 143, 255);
  }
}
.comHeaderWrap {
  // height: 120px;
  width: 100%;
  min-width: 1280px;
  // min-width: 1920px;

  // min-width: 1800px;
  // width: 52.5%;
  // padding: 0 20px;
  // margin: auto;
  z-index: 100;
  margin: auto;
  // background: #fdebd6;
  // background: #ffc27b;
  background: #ffffff;
  //  background: rgb(250, 208, 93);
  // position: absolute;
  // top: 0px;
  // background: url("../assets/imgs/亮点图标/top.jpg");
  // display: flex;
  // justify-content: center;
  // background: #fdebd6;
  // background: #fd8d1c;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.comHeader {
  // width: 1800px;
  width: 100%;
  min-width: 1280px;
  padding: 0 10px;
  // margin: auto;
  background: url("../assets/imgs/亮点图标/top.jpg");
  display: flex;
  justify-content: center;
  // padding: 0 5%;
}
.logo {
  // padding: 0 20px;
  img {
    width: 140px;
  }
}
.comHeader_right {
  // padding: 0 20px;
  height: 60px;
  display: flex;
  align-items: center;
  color: #0e101a;
  .el-button--text {
    margin: 10px;
    padding: 0 20px;
    font-size: 21px;
    // color: white;
    .homeLink {
      // color: white;
    }
    .homeLink :hover {
      color: rgb(96, 161, 235);
    }
  }
  .el-button--text :hover {
    color: rgb(96, 161, 235);
  }
}
.comHeader_bottom {
  width: 100%;
  max-width: 1280px;
  // padding: 0 3%;
  // max-width: 2500px;
  margin: auto;
  display: flex;
  justify-content: space-between;

  // padding: 0 10%;
  // max-width: 1100px;
  // margin: 0 auto;
  // background: rgba(243, 227, 227, 0.5);
  // color: white;
  // background: #fdebd6;
  .title_logo {
    line-height: 60px;
    width: 230px;
    font-family: "庞门正道标题";
    color: white;
    font-size: 25px;
  }
  .title_logo:hover {
    cursor: pointer;
  }
  .el-menu {
    // margin-left: 10%;
    margin: 0 0 0 0% !important;
    // width: 90%;
    max-width: 1280px;
    background: none;
    border: none;
    // background: #faf2ea;
  }
  .el-menu-item {
    height: 60px;
    // width: 60px;
    line-height: 60px;
    // color: #ffffff !important;
    // border: none;
  }
  .opening_:hover {
    outline: 0 !important;
    // color: #ff8923 !important;
    // background: none !important;
    // border-bottom: 2px solid rgb(0, 0, 0) !important;
    // background: #fcc602 !important;
    background: rgba(252, 198, 2, 0.5) !important;
    color: #ffffff !important;
  }
  .el-menu-item.is-active {
    // color: #ff8923 !important;
    color: rgb(0, 0, 0) !important;
    // color: #ffffff !important;
    background: none !important;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    // border-bottom: 2px solid rgb(0, 0, 0);
    border: none;

    // border: none !important;
    font-weight: 900;
    background: #fcc602 !important;
    color: #ffffff !important;
    // background: #faf2ea;
  }
  .el-menu--horizontal > .el-menu-item {
    font-size: 18px;
  }
}
// 登录样式
/deep/.el-dialog {
  width: 30%;
  .el-dialog__header {
    text-align: center;
  }
  .el-dialog__body {
    padding: 10px 30px;
  }
  .el-dialog__footer {
    padding: 0 20px 10px;
    .dialog-footer {
      display: flex;
      justify-content: space-around;
    }
  }
}
.dialog-footer {
  .el-button {
    width: 120px;
  }
}
.backPass :hover {
  color: rgb(53, 181, 255);
  cursor: pointer;
}
.backPass {
  display: flex;
  justify-content: flex-end;
  span {
    display: inline-block;
  }
}
.logintext:hover {
  color: rgb(169, 208, 243) !important;
}
</style>
